import { FC } from 'react'
import PerIcon from '../Icon'
import PerText from '../Text'
import { icons } from '../Icon/icons'

type PerAtAGlanceElementProps = {
  icon: keyof typeof icons
  heading: string
  info: string
}

export const PerAtAGlanceElement: FC<PerAtAGlanceElementProps> = ({ children, icon, heading, info }) => {
  return (
    <div className="per-flexRow--growShrink textAlign--center" style={{ maxWidth: '500px' }}>
      <PerIcon name={icon} size={40} variant="decoration" color="secondary" />
      <PerText fontWeight="bold" mt="xxs" fontSize="m">
        {heading}
      </PerText>
      <PerText color="secondary" mt="xxs" mb="xs" fontSize="s">
        {info}
      </PerText>
      {children}
    </div>
  )
}
